import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme
} from "@mui/material";
import Switch from "@mui/material/Switch";
import { Info24Px } from "@qubit/autoparts";
import type { ReactNode } from "react";

import { settingsUtilityLabelColumnWidthPx } from "~/features/settings/settings.styles";

export type SettingsToggleProps = {
  labelId: string;
  label: string;
  infoTooltip: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  trailingComponents?: ReactNode;
};

export function SettingsToggle(props: SettingsToggleProps) {
  const {
    labelId,
    label,
    infoTooltip,
    checked,
    onChange,
    disabled,
    trailingComponents
  } = props;
  const theme = useTheme();

  return (
    <FormControl sx={{ width: "100%", maxWidth: 560 }} variant="standard">
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="nowrap"
        gap={1}
        sx={{ width: "100%" }}
      >
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="nowrap"
          gap={0.75}
          sx={{
            flex: `0 0 ${settingsUtilityLabelColumnWidthPx}px`,
            width: settingsUtilityLabelColumnWidthPx,
            minWidth: 0,
            boxSizing: "border-box"
          }}
        >
          <FormLabel
            htmlFor={labelId}
            sx={{
              m: 0,
              minWidth: 0,
              color: "text.primary",
              "&.Mui-focused": { color: "text.primary" }
            }}
          >
            <Typography variant="body2" component="span" fontWeight={400}>
              {label}
            </Typography>
          </FormLabel>
          <Tooltip title={infoTooltip}>
            <IconButton
              size="small"
              aria-label={`${label} info`}
              sx={{ flexShrink: 0 }}
            >
              <Info24Px fill={theme.palette.darkGray.main} />
            </IconButton>
          </Tooltip>
        </Stack>
        <Switch
          id={labelId}
          size="small"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          sx={{ flexShrink: 0 }}
        />
        {trailingComponents != null && trailingComponents !== false ? (
          <Box sx={{ minWidth: 0, flex: "1 1 auto" }}>{trailingComponents}</Box>
        ) : null}
      </Stack>
    </FormControl>
  );
}
